import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"heart\"><path d=\"m8 14-1.16-1.007C2.72 9.43 0 7.08 0 4.196 0 1.846 1.936 0 4.4 0 5.792 0 7.128.618 8 1.595 8.872.618 10.208 0 11.6 0 14.064 0 16 1.846 16 4.196c0 2.884-2.72 5.234-6.84 8.805z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol